
export default class Timeline {

	static getHolderSelectors = () => ['.timeline-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		const slider = new Splide(holderElement.querySelector('.splide'), {
			autoWidth: true,
			arrows: false,
			pagination: false,
		});

		slider.mount();


		const eraButtons = this.#holderElement.querySelectorAll('.eras button');
		eraButtons.forEach(btn => btn.addEventListener('click', event => {
			slider.go(parseInt(event.currentTarget.dataset.slideIndex));
			eraButtons.forEach(btn => btn.classList.remove('active'));
			event.currentTarget.classList.add('active');
		}));


		const arrowBack = this.#holderElement.querySelector('[data-slider-control="<"]');
		const arrowForward = this.#holderElement.querySelector('[data-slider-control=">"]');
		const arrowButtons = [arrowBack, arrowForward];
		arrowButtons.forEach(btn => btn.addEventListener('click', event => {
			const direction = event.currentTarget.dataset.sliderControl;
			slider.go(direction);
		}));

		slider.on('moved', (newIndex, prevIndex, destIndex) => {
			arrowBack.removeAttribute('disabled');
			arrowForward.removeAttribute('disabled');
			if (newIndex === 0) {
				arrowBack.setAttribute('disabled', 'true');
			} else if (newIndex+1 === slider.length) {
				arrowForward.setAttribute('disabled', 'true');
			}
		});
	}

}
